<template>
  <el-table-column v-if="editable===false"
    :label="label"
    :width="width"
    :prop="prop"
    :sortable="sortable"
  />
  <el-table-column v-else
    :label="label"
    :width="width"
    :prop="prop"
    :sortable="sortable"
  >
    <template slot-scope="scope">
      <el-form-item
        :prop="tableDataName + '.' + scope.$index + '.' + prop"
        :rules="rules"
      >
          <!-- :value="getter(scope.row[prop])" -->
        <el-select
          v-model="scope.row[prop]"
          @change="setter"
          :placeholder="placeholder"
          :disabled="disabled === true ? disabled : addRowMode === false ? disabled : !changeable(addRowMode, changeCase, tableDataCount, scope.$index)"
          :autofocus="autofocus"
          :required="required"
          :clearable="false"
          :filterable="filterable"
        >
          <el-option v-if="!required" label="" value="" />
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <!-- <span style="float: left; color: #8492a6; font-size: 13px">{{item.value}}</span> -->
            <span style="display: none;">{{item.value}}</span>
            <span style="float: left; margin-left: 10px">{{item.label}}</span>
          </el-option>
        </el-select>
      </el-form-item>
    </template>
  </el-table-column>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    label: {
      type: String,
      default: '汎用プルダウン'
    },
    prop: {
      type: String,
      default: 'select'
    },
    sortable: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    validator: {
      type: String,
      default: undefined
    },
    width: {
      type: String,
      default: ''
    },
    addRowMode: {
      type: Boolean,
      default: false
    },
    changeable: {
      type: Function,
      default: () => true
    },
    changeCase: {
      type: String,
      default: ''
    },
    tableDataCount: {
      type: Number,
      default: 0
    },
    tableDataName: {
      type: String,
      default: 'tableData'
    },
    optionsList: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: []
    }
  },
  computed: {
    rules: {
      get () {
        const rules = []
        // if (!this.disabled) {
        if (this.required) {
          rules.push(this.validatorRequired(this.label, 'change'))
        }
        // }
        return rules
      }
    }
  },
  mounted () {
    const root = document.documentElement
    root.style.setProperty('--width', this.width)
    // console.log(this.optionsList)
    // const optionsListSet = this.optionsList.map(function (index, array) {
    //   return { value: index.value, label: index.label }
    // })
    // console.log(optionsListSet)
    // this.options = optionsListSet
    // this.optionsOriginal = optionsListSet
    // this.options = this.optionsList
    // this.optionsOriginal = this.optionsList
  },
  watch: {
    optionsList: function (newList, oldList) {
      console.log(newList)
      console.log(oldList)
      // this.options = newList
      // this.optionsOriginal = newList
      // this.options = this.optionsOriginal
      this.options = []
      for (let i = 0; i < newList.length; i++) {
        const row = {}
        row.label = newList[i].value + ':' + newList[i].label
        row.value = newList[i].value
        this.options.push(row)
      }
    }
  },
  methods: {
    getter (value) {
      return value
    },
    setter (value) {
      // this.$emit('input', value)
      this.$emit('change', value)
      // this.options = this.optionsOriginal
    }
    // filter (a) {
    //   this.options = this.optionsOriginal.filter((x) => {
    //     return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
:root {
  --width: 100px;
}
.el-table {
  th,
  td {
    &.text-column {
      width: var(--width);
    }
  }
}
</style>
